var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile is-centered"},[_c('div',{staticClass:"column is-4 text-center"},[_c('h1',{staticClass:"title mb-2"},[_vm._v(_vm._s(_vm.$t('notfound.title')))]),_c('img',{staticClass:"notfound_image",attrs:{"src":require("@/assets/404.gif"),"alt":"404"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }